module.exports = __webpack_public_path__ + "static/media/desktopAddMobileWalletIcon.da3ce1d6.svg";